export const execCommittee = [
  //
  {
    name: "Dr. Alan LaFave",
    title: "NSU President, (non-voting-member)",
    image: "assets/media/pages/about/staff-headshots/alan-lafave.webp",
  },
  // Zach Flakus
  {
    name: "Zach Flakus",
    title: "Foundation President/CEO, (non-voting member)",
    image: "assets/media/pages/about/staff-headshots/zach-flakus-exec.webp",
  },

  // MarkUp #234: Jared Jacobson removed
  // Alex Grieben
  {
    name: "Alex Grieben",
    // MarkUp #235
    title: "Chair",
    image: "assets/media/pages/about/staff-headshots/alex-grieben.webp",
  },
  // Eric Payne
  {
    name: "Eric Payne",
    title: "Secretary",
    image: "assets/media/pages/about/staff-headshots/eric-payne.webp",
  },
  // Megan Biegler
  {
    name: "Megan Biegler",
    title: "Past-Chair",
    image: "assets/media/pages/about/staff-headshots/megan-biegler.webp",
  },
  // Greg Wieker
  {
    name: "Greg Wieker",
    title: "Treasurer",
    image: "assets/media/pages/about/staff-headshots/greg-wieker.webp",
  },
  // Rod Tobin
  {
    name: "Rod Tobin",
    title: "Legal Counsel",
    image: "assets/media/pages/about/staff-headshots/rod-tobin.webp",
  },
];
